import { InfinitySpin , MutatingDots } from "react-loader-spinner";


function Loading() {
    return (
        <div className="min-h-screen flex justify-center items-center">
            {/* <InfinitySpin
                visible={true}
                width="200"
                color="#FF0000"
                ariaLabel="infinity-spin-loading" /> */}

<MutatingDots
  visible={true}
  height="100"
  width="100"
                color="#FF0000"
  secondaryColor="#FF0000"
  radius="12.5"
  ariaLabel="mutating-dots-loading"
  wrapperStyle={{}}
  wrapperClass=""
  />
        </div>
    );
}
export default Loading;